import {getStateXml, getCompressedData} from '../../../_shared/GWTBridge/invoke/server';
import {writeLog} from '../../../_shared/GWTBridge/invoke/common';
import {buildFormServerCall} from '../../services/formService';
import {ViewType} from '../../Form/consts/viewTypes';
import {addFormOperation} from '../../../_shared/GWTBridge/invoke/netForm';
import {Keys} from '../../Form/consts/keys';
import {Form} from '../../Form/stores/Form';

export async function executeCustomSearch(
    currentForm: Form,
    json,
    ignoreCase,
    name,
    addToList = false,
    ignoreGoFiled = false
) {
    const reason = 'Execute/Add Query';
    const methodName = 'FormQueryDlgExecute';

    if (currentForm.formType === ViewType.RECON) {
        addFormOperation({
            ...currentForm.formState,
            key: Keys.None
        });
    }

    const statexml = getStateXml(currentForm.session);
    const xml = getCompressedData(json, 'QueryDlg');
    /* parameters of type boolean should be converted to string of type "false" | "true" */
    const ic = ignoreCase.toString();
    writeLog(`${reason} (${methodName})`, xml.original);
    const parameters = {
        statexml: [statexml],
        add: [addToList.toString()],
        xml: [xml.compressed],
        ic: [ic],
        queryname: [name]
    };
    return await buildFormServerCall(
        methodName,
        parameters,
        reason,
        true,
        true,
        true,
        currentForm.session,
        ignoreGoFiled ? 'ignoreGoFiled' : null
    );
}

export function generatorOpenDateSearchField() {
    const statexml = getStateXml();
    const parameters = {statexml: [statexml], id: ['-1'], mode: ['0'], editvalue: ['']};
    return buildFormServerCall('FormAlertChoose', parameters, 'Choose', false);
}

export async function saveSearch(searchIdx, json, ignoreCase, name) {
    const methodName = 'FormQueryDlgSave';
    const reason = 'Save Query';
    const statexml = getStateXml();
    const xml = getCompressedData(json, 'QueryDlg');
    /* parameters of type boolean should be converted to string of type "false" | "true" */
    const ic = ignoreCase.toString();
    writeLog(`${reason} (${methodName})`, xml.original);
    const parameters = {
        statexml: [statexml],
        query: [searchIdx],
        xml: [xml.compressed],
        ic: [ic],
        queryname: [name]
    };
    return await buildFormServerCall(methodName, parameters, reason, true);
}
